//
// Imports
//

import * as BrowserUtilities from "@donutteam/browser-utilities";

import * as UserPreferenceClientLib from "../../../libs/client/UserPreference.client.js";

import * as UserPreferenceSchemaLib from "../../../libs/schemas/UserPreference.js";

//
// Component
//

export function initialiseDesignPreferencesForm(designPreferencesForm: HTMLElement)
{
	const apiUrl = BrowserUtilities.ElementClientLib.getStringDataOrThrow(designPreferencesForm, "apiUrl");

	designPreferencesForm.addEventListener("submit", (event) => event.preventDefault());

	const themeSelect = BrowserUtilities.ElementClientLib.getElementOrThrow<HTMLInputElement>(designPreferencesForm, `select[name="global::theme"]`);

	themeSelect.addEventListener("change", 
		() =>
		{
			const theme = UserPreferenceSchemaLib.StoreSchema.shape["global::theme"].parse(themeSelect.value);

			UserPreferenceClientLib.updateValue(apiUrl, themeSelect, "global::theme", theme);

			document.body.classList.remove("theme-auto", "theme-light", "theme-dark");

			document.body.classList.add("theme-" + theme);
		});

	const longNumbersInput = BrowserUtilities.ElementClientLib.getElementOrThrow<HTMLInputElement>(designPreferencesForm, `input[name="global::long_numbers"]`);

	longNumbersInput.addEventListener("change", () => UserPreferenceClientLib.updateValue(apiUrl, longNumbersInput, "global::long_numbers", longNumbersInput.checked));

	const compactForumTopicListingInput = BrowserUtilities.ElementClientLib.getElementOrThrow<HTMLInputElement>(designPreferencesForm, `input[name="forum::compact_forum_topic_listing"]`);

	compactForumTopicListingInput.addEventListener("change", () => UserPreferenceClientLib.updateValue(apiUrl, compactForumTopicListingInput, "forum::compact_forum_topic_listing", compactForumTopicListingInput.checked));

	const mutedForumTopicFlairsInput = BrowserUtilities.ElementClientLib.getElementOrThrow<HTMLInputElement>(designPreferencesForm, `input[name="forum::muted_forum_topic_flairs"]`);

	mutedForumTopicFlairsInput.addEventListener("change", () => UserPreferenceClientLib.updateValue(apiUrl, mutedForumTopicFlairsInput, "forum::muted_forum_topic_flairs", mutedForumTopicFlairsInput.checked));

	designPreferencesForm.classList.add("initialised");
}

export function initialiseDesignPreferencesForms()
{
	const designPreferencesForms = document.querySelectorAll<HTMLFormElement>(".component-design-preferences-form:not(.initialised)");

	console.log("[DesignPreferencesForm] Initialising " + designPreferencesForms.length + " instances...");

	for (const designPreferencesForm of designPreferencesForms)
	{
		try
		{
			initialiseDesignPreferencesForm(designPreferencesForm);
		}
		catch (error)
		{
			console.error("[DesignPreferencesForm] Error initialising:", designPreferencesForm, error);
		}
	}
}